import { Controller } from "@hotwired/stimulus"

// Toggles the active-startup dropdown on the flightplan header. Closes on
// outside click or Escape.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.outsideClickListener = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    this.keyListener = (event) => {
      if (event.key === "Escape") this.close()
    }
    document.addEventListener("click", this.outsideClickListener)
    document.addEventListener("keydown", this.keyListener)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickListener)
    document.removeEventListener("keydown", this.keyListener)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }
}
